import { Inject, Injectable } from "@angular/core";
import { DEVICE_POLLING_REST_SERVICE } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";
import { NmsAutoPollingService } from "./nms-auto-polling.service";
import { Observable } from "rxjs";
import { RefreshIntervalService } from "@nms-ng2/app/shared/services/refresh-interval/refresh-interval.service";

/**
 * Servico responsável por gerenciar o NmsAutoPollingService facilitando sua utilização
 * em componentes do AngularJS, pois como o NmsAutoPollingService não é utilizado como singleton,
 * não é possível injetar diretamente nos serviços antigos.
 */
@Injectable({
    providedIn: "root"
})
export class NmsAutoUpdaterManagerService {

    nmsAutoPollingService: NmsAutoPollingService;

    constructor(@Inject(DEVICE_POLLING_REST_SERVICE) readonly devicePollingRestService: any,
            readonly refreshIntervalService: RefreshIntervalService) {
        this.nmsAutoPollingService = new NmsAutoPollingService(this.devicePollingRestService);
    }

    startDevicesPolling() {
        return this.nmsAutoPollingService.startDevicesPolling();
    }

    setup(deviceId: number[], callback: () => Observable<any>) {
        this.nmsAutoPollingService.setup(deviceId, callback);
    }

    getFeedbackMessage() {
        return this.nmsAutoPollingService.pollingFeedbackMessage;
    }

    getRefreshInterval(callback) {
        this.refreshIntervalService.getRefreshInterval(callback);
    }

}
